import {
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Spin,
  Typography,
} from "antd";

import { formatModalBalanceDisplay } from "../../../utilites/tasksBalance";

const { Text } = Typography;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

/**
 * نافذة تقديم/تعديل إجازة — نفس هيكل attendance-table.
 * • children: يُدرج بين «مدة الإجازة» و«نوع الإجازة» (مثلاً جدول بصمات tasks-table).
 */
export default function VacationSubmitModal({
  open,
  onCancel,
  onOk,
  confirmLoading,
  modalKey,
  title = "تقديم إجازة / مهمة",
  form,
  initialValues,
  rangePickerProps,
  totalVac,
  taskTypeSelectProps,
  givenTasks,
  restTasks,
  notesRows = 3,
  children,
  taskTypeFormItemProps = {},
  selectFooter,
}) {
  const { onChange: taskTypeOnChange, ...restTaskTypeSelectProps } =
    taskTypeSelectProps || {};
  const taskTypeOptions = restTaskTypeSelectProps?.options || [];
  const taskTypeFieldKey = `task-type-${modalKey ?? "modal"}-${taskTypeOptions.length}-${initialValues?.task_type ?? "none"}`;

  return (
    <Modal
      key={modalKey}
      centered
      title={title}
      confirmLoading={confirmLoading}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form
        form={form}
        key={modalKey}
        initialValues={initialValues}
        preserve={false}
      >
        <Form.Item
          className="rangee"
          name="date_range"
          label="فترة الإجازة / المهمة :"
        >
          <RangePicker {...rangePickerProps} />
        </Form.Item>
        <div style={{ marginTop: "-12px", marginBottom: "12px", fontWeight: 600 }}>
          مدة الإجازة: <Text type="danger">{totalVac}</Text>
        </div>
        {children}
        <Form.Item
          style={{ marginTop: "10px" }}
          name="task_type"
          label="نوع الإجازة"
          {...taskTypeFormItemProps}
        >
          <Select
            key={taskTypeFieldKey}
            showSearch
            optionFilterProp="label"
            notFoundContent={<Spin style={{ textAlign: "center" }} />}
            style={{ width: 150 }}
            placeholder="نوع الإجازة"
            filterOption={(input, option) =>
              String(option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              String(optionA?.label ?? "").localeCompare(
                String(optionB?.label ?? ""),
              )
            }
            {...restTaskTypeSelectProps}
            onChange={(value, option) => {
              taskTypeOnChange?.(value, option);
            }}
          />
        </Form.Item>
        <div
          style={{
            marginTop: "-8px",
            marginBottom: "12px",
            marginRight: "10px",
          }}
        >
          الممنوحة:{" "}
          <span
            style={{
              fontWeight: "600",
              color: "#f00",
              marginLeft: "20px",
            }}
          >
            {formatModalBalanceDisplay(givenTasks)}
          </span>{" "}
          المتبقية:{" "}
          <span style={{ fontWeight: "600", color: "#f00" }}>
            {formatModalBalanceDisplay(restTasks)}
          </span>
        </div>
        {selectFooter}
        <Form.Item name="notes" label="تفاصيل ">
          <TextArea
            rows={notesRows}
            allowClear
            autoComplete="off"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
